
















































































































































































































































































import {
  WorkflowFormFieldOption,
  IWorkflowFormFieldData,
  IWorkflowFormFieldOptionData,
  IWorkflowFormSectionFieldData,
  ISystemError
} from '@/models';
import Draggable from 'vuedraggable';
import { PropType } from 'vue';
import { ALForm } from '@/common/component.types';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import FileUploadRulesMixin from '@/mixins/file-upload-rules';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { setErrorFromAxiosError } from '@/utils/helpers';
import { AxiosError } from 'axios';

const baseMixins = mixins(Proxyable, FileUploadRulesMixin);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'FormBuilderOptionTabWindow',

    components: { ALDialog, Draggable, ConfirmationDialog, DragDropFileInput },

    inject: {
      isFormDisabled: {
        default: false
      }
    },

    props: {
      value: Object as PropType<IWorkflowFormSectionFieldData>
    },

    data() {
      return {
        selectedOptionsIndex: -1 as number,
        selectedEditOptionsIndex: -1 as number,
        deleteDialog: false,

        error: null as ISystemError | null,
        file_upload: null as File | null,
        isUploadFormValid: false,
        isUploading: false,
        isUploadDialogActive: false
      };
    },

    computed: {
      ...mapGetters({
        getOptionTodosBySectionFieldAndOptionId:
          'workflowFormTemplate/getOptionTodosBySectionFieldAndOptionId',
        getWorkflowFormFieldOptionTodos:
          'workflowFormTemplate/getWorkflowFormFieldOptionTodos'
      })
    },

    watch: {
      getWorkflowFormFieldOptionTodos: {
        handler(value) {
          const canCreateTodo = value.length > 0;
          this.internalValue.create_todo = canCreateTodo;
        },
        immediate: true
      }
    },

    methods: {
      ...mapActions({
        uploadWorkflowFormFieldOptions:
          'workflowFormTemplate/uploadWorkflowFormFieldOptions'
      }),

      closeDeleteDialog() {
        this.selectedEditOptionsIndex = -1;
        this.selectedOptionsIndex = -1;
        this.deleteDialog = false;
      },

      clearAllErrors() {
        this.error = null;
      },

      setSelectedOption(option: IWorkflowFormFieldOptionData) {
        this.$emit('openTodoDrawer', option);
      },

      reorderFieldTemplateOptions() {
        (this.internalValue
          .field_template as IWorkflowFormFieldData).options = (this
          .internalValue.field_template as IWorkflowFormFieldData).options?.map(
          (option, i) => {
            return {
              ...option,
              order: i
            };
          }
        );
      },

      openDialog(index: number) {
        this.selectedOptionsIndex = index;
        this.deleteDialog = true;
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      removeFieldTemplateOption() {
        (this.internalValue
          .field_template as IWorkflowFormFieldData).options?.splice(
          this.selectedOptionsIndex!,
          1
        );

        //sync todo options and field options
        this.$emit('save');
        this.closeDeleteDialog();
        this.$emit('loadFieldOptionsTodos');
      },

      uploadFieldTemplateOptionHandler() {
        this.clearAllErrors();

        if (this.validateForm()) {
          this.isUploading = true;
          try {
            this.uploadWorkflowFormFieldOptions({
              fieldId: (this.internalValue
                .field_template as IWorkflowFormFieldData).id!,
              file: this.file_upload
            }).then((optionsData: IWorkflowFormFieldOptionData[]) => {
              const options = optionsData.map(
                option => new WorkflowFormFieldOption(option)
              );

              (this.internalValue
                .field_template as IWorkflowFormFieldData).options?.push(
                ...options
              );
              this.isUploadDialogActive = false;
              this.$emit('save');
            });
          } catch (err) {
            this.error = setErrorFromAxiosError(err as AxiosError);
          } finally {
            this.isUploading = false;
          }
        }
      },

      addFieldTemplateOption() {
        const option = new WorkflowFormFieldOption({
          value: 'New Option',
          field: (this.internalValue.field_template as IWorkflowFormFieldData)
            .id!,
          order:
            (this.internalValue.field_template as IWorkflowFormFieldData)
              .options!.length + 1!
        });

        (this.internalValue
          .field_template as IWorkflowFormFieldData).options?.push(option);

        this.selectedOptionsIndex =
          (this.internalValue.field_template as IWorkflowFormFieldData).options!
            .length! - 1;

        this.$emit('save');

        //opens newly create option for editting
        this.selectedEditOptionsIndex =
          (this.internalValue.field_template as IWorkflowFormFieldData).options!
            .length - 1!;
      }
    }
  });
